
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Zwei Psychologen der Technischen Universität in München haben vor einigen Jahren 138 Probanden gebeten, ein virtuelles Schlafzimmer nach ihrem Gutdünken einzurichten. Das Resultat erstaunte: `}<M mdxType="M">{`70 Prozent der Teilnehmenden platzierten das Bett so weit von der Schlafzimmertür entfernt wie nur möglich.`}</M>{` Zudem wählten fast alle einen Platz mit Blick zur Tür, um eine schnelle Reaktion auf potenzielle Einbrecher oder Angreifer zu ermöglichen. Wie auch bei anderen Verhaltensweisen – siehe zum Beispiel Frage  5 – scheinen sich auch hier Ängste unserer Vorfahren zu offenbaren: Wer in der Steinzeit die Augen schloss, machte sich verletzlich. Jederzeit konnte ihn ein Feind oder ein wildes Tier angreifen. Diese Angst sorgt bis heute dafür, dass wir in einer Art Sicherheitsmodus schlafen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;